import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

export interface ProjectCardRowProps extends WithClassName {
  children?: React.ReactNode
}

export const ProjectCardRow = React.memo(
  ({ children, className }: ProjectCardRowProps) => (
    <div className={classNames("project-card__row", className)}>{children}</div>
  )
)
